import { useTranslation } from "react-i18next";

import { Image, Stack, Title } from "@mantine/core";

import IMAGE from "@/assets/promo/WAKU-Care-Logo-Cloud.svg";
import LoginForm from "@/components/Login/LoginForm";

export const LoginPage = () => {
  const { t } = useTranslation();

  return (
    <Stack p="lg">
      <Image src={IMAGE} h={200} />
      <Title order={1} mx="auto">
        {t("page-title.login")}
      </Title>

      <LoginForm />
    </Stack>
  );
};

export default LoginPage;
